import axios from 'axios'

const fetchAnswer = answerHashId => axios.get(`/v1/answers/${answerHashId}.json`).then(res => res.data)

const validateDocumentUniqueness = (formId, docId, docType) =>
  axios.post(`/v1/forms/${formId}/validate_doc_number.json`, { doc_id: docId, doc_type: docType })

export { fetchAnswer, validateDocumentUniqueness }
